import React from "react";
import { HashLink } from "react-router-hash-link";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const Orthodontics = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const seo = t("orthodontics.seo", { returnObjects: true });
  const content = t("orthodontics.content", { returnObjects: true });

  return (
    <div className="container py-5 mt-5" dir={lang === "ar" ? "rtl" : "ltr"}>
      <Helmet>
        <link rel="canonical" href="https://saleemsmile.com/articles/orthodontics" />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta property="og:title" content={seo.ogTitle} />
        <meta property="og:description" content={seo.ogDescription} />
        <meta
          property="og:image"
          content="https://via.placeholder.com/800x450.png?text=Orthodontics+Dental+Care"
        />
        <meta property="og:type" content="article" />
        <meta property="og:locale" content={lang === "ar" ? "ar_AR" : "en_US"} />
      </Helmet>

      {/* Page Content */}
      <h1 className="mb-4 text-center" style={{ color: "#00b3ff" }}>
        {t("orthodontics.header")}
      </h1>
      <h5 className="text-center mb-5">{t("orthodontics.subtitle")}</h5>
      <p className="text-center">{t("orthodontics.intro")}</p>

      <h2 className="mt-4">{content.definitionTitle}</h2>
      <p>{content.definitionText}</p>
      <ul>
        {content.definitionList.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{content.benefitsTitle}</h2>
      <ul>
        {content.benefitsList.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{content.typesTitle}</h2>
      {Object.values(content.types).map((type, idx) => (
        <div key={idx}>
          <h3 className="mt-3">{type.title}</h3>
          <p>{type.desc}</p>
        </div>
      ))}

      <h2 className="mt-4">{content.durationTitle}</h2>
      <p>{content.durationText}</p>

      <h2 className="mt-4">{content.startTitle}</h2>
      <p>{content.startText}</p>

      <h2 className="mt-4">{content.careTitle}</h2>
      <ul>
        {content.careList.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{content.whyTitle}</h2>
      <ul>
        {content.whyList.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <footer className="mt-4">
        <HashLink to="/#services" className="btn btn-outline-secondary">
          {t("orthodontics.backBtn")}
        </HashLink>
      </footer>
    </div>
  );
};

export default Orthodontics;
